import { render, staticRenderFns } from "./mobile-phone-verification.vue?vue&type=template&id=2599f056&scoped=true"
import script from "./mobile-phone-verification.vue?vue&type=script&lang=js"
export * from "./mobile-phone-verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599f056",
  null
  
)

export default component.exports